import { BREAKPOINT_WIDTH } from '~/js/constants/breakpoints'

const ID_HEADER = 'js-snippetsHeader'
export const CLASS_NAME_SCROLL_TRIGGER = 'js-scrollTrigger'

document.addEventListener('DOMContentLoaded', () => {
  const elementsScrollTrigger = document.getElementsByClassName(
    CLASS_NAME_SCROLL_TRIGGER
  )
  if (elementsScrollTrigger.length)
    Array.from(elementsScrollTrigger).forEach((element) => {
      setEventScroll(element)
    })
})

export const setEventScroll = (element) => {
  element.addEventListener('click', () => {
    const idScrollTarget = element.dataset.idScrollTarget
    scroll(idScrollTarget)
  })
}

export const scroll = (idScrollTarget) => {
  const elementTarget = document.getElementById(idScrollTarget)
  if (!elementTarget) return

  const elementHeader = document.getElementById(ID_HEADER)
  const headerHeight = Number(elementHeader?.dataset.height || 0)
  const mobileOffset =
    window.innerWidth < BREAKPOINT_WIDTH
      ? Number(elementTarget?.dataset.scrollOffsetMobile || 0)
      : 0
  const clientRect = elementTarget.getBoundingClientRect()
  const top =
    Number(window.scrollY) + clientRect.top - headerHeight - mobileOffset
  window.scrollTo({
    top,
    behavior: 'smooth',
  })
}

export const scrollStickyHeader = (elementTarget) => {
  if (!elementTarget) return

  const elementHeader = document.getElementById(ID_HEADER)
  const headerHeight = Number(elementHeader?.dataset.height || 0)
  const top =
    Number(window.scrollY) +
    elementTarget.getBoundingClientRect().top -
    headerHeight
  window.scrollTo({
    top,
    behavior: 'smooth',
  })
}
